var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewServiceQuickServiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V6.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7849 7.87088C11.8813 7.70531 12.1205 7.70531 12.2169 7.87088L13.4002 9.90247C13.4355 9.96312 13.4947 10.0061 13.5633 10.021L15.8612 10.5186C16.0484 10.5591 16.1223 10.7866 15.9947 10.9295L14.4282 12.6827C14.3814 12.735 14.3588 12.8046 14.3659 12.8744L14.6027 15.2135C14.622 15.4042 14.4285 15.5448 14.2532 15.4675L12.1017 14.5194C12.0375 14.4911 11.9643 14.4911 11.9001 14.5194L9.74865 15.4675C9.57332 15.5448 9.37981 15.4042 9.39911 15.2135L9.63595 12.8744C9.64302 12.8046 9.62041 12.735 9.57364 12.6827L8.00714 10.9295C7.87948 10.7866 7.95339 10.5591 8.14066 10.5186L10.4385 10.021C10.5071 10.0061 10.5663 9.96312 10.6016 9.90247L11.7849 7.87088Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewServiceQuickServiceIcon);
export default __webpack_public_path__ + "static/media/new-service-quick-service-icon.4ee53ae9ff8cd5ecd0d009c9dac40d8e.svg";
export { ForwardRef as ReactComponent };